import React from "react"
import { NoResultsItem } from "@app/types"

type Props = {
  searchPage?: boolean
}

export function SearchNoResults({ searchPage = false }: Props) {
  const items: NoResultsItem[] =
    window?.SHOPIFY_DATA.searchDrawerData?.items || []

  if (!items?.length) return null

  const visibleItems = searchPage ? items.slice(0, 3) : items

  return (
    <div className={`search-no-results ${searchPage ? "search-page" : ""}`}>
      <div className="search-no-results--grid">
        {visibleItems?.map((item, index) => (
          <a
            key={index}
            href={item.button_url}
            className="search-no-results--card"
          >
            <div className="search-no-results--card">
              <img
                src={`${item.image}&width=600`}
                srcSet={`
                  ${item.image}&width=400 400w,
                  ${item.image}&width=800 800w
                `}
                alt={item.heading}
                className="search-no-results--image"
              />
              <div className="search-no-results--heading">
                <p
                  style={searchPage ? { color: item?.text_colour } : undefined}
                >
                  {item.heading}
                </p>
                <span
                  className="search-no-results--underline"
                  style={
                    searchPage ? { borderColor: item?.text_colour } : undefined
                  }
                />
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}
